import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import LinkedEmails from '@nykaa/nes-auth/components/LinkedEmails';
import Toast, { VARIANT } from '@nykaa/nes-ui-components/Toast';
import { SUBTITLES, TOAST_TIMER } from '@nykaa/nes-auth-shared/constants';
import {
  pushAuthScreen,
  replaceAuthScreen,
} from '@nykaa/nes-auth-shared/store/utils';
import {
  increaseAuthStepInHistory,
  getAuthStepFromHistory,
} from '@nykaa/nes-auth-shared/utils';
import {
  API_PARAM_KEYS,
  SCREEN_TYPE,
  USER_VERSION_1,
} from '@nykaa/nes-auth-shared/store/constants';
import useAuthData from '@nykaa/nes-auth-shared/hooks/useAuthData';

const { otpReader, passwordReader } = SCREEN_TYPE;

const LinkedEmailScreen = (showNudge: boolean) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { loading, message, emailList, isApiError } = useAuthData();
  const authStateSteps = getAuthStepFromHistory(history);
  const handleCreateAccount = useCallback(() => {
    replaceAuthScreen({
      dispatch,
      positionOfInterest: authStateSteps,
      stepData: {
        stepName: otpReader,
      },
    });
  }, [dispatch, authStateSteps]);

  const handleSendOTP = useCallback(
    ({ email, customerId, signUpSource = '', userVersion }) => {
      let stepData = { stepName: otpReader };
      if (
        signUpSource.toLowerCase() === API_PARAM_KEYS.email &&
        userVersion === USER_VERSION_1
      ) {
        stepData.stepName = passwordReader;
      }
      pushAuthScreen({
        dispatch,
        positionOfInterest: authStateSteps,
        stepData,
        authResponseData: {
          email,
          selectedCustomerId: customerId,
        },
      });
      increaseAuthStepInHistory(history);
    },
    [dispatch, history, authStateSteps]
  );

  return (
    <>
      <LinkedEmails
        subTitle={SUBTITLES.linkedEmail}
        emailList={emailList}
        getOTP={handleSendOTP}
        createAccount={handleCreateAccount}
        isLoading={loading}
        isNudge={showNudge}
      />
      {isApiError && (
        <Toast
          timer={TOAST_TIMER}
          message={message}
          variant={VARIANT.single}
        />
      )}
    </>
  );
};
export default LinkedEmailScreen;
